import { UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useGetKeywordSearchMagazineCursorPageQuery } from '@/hooks/magazine/mobile/magazine.gql.impl';
import * as Types from '@/types/bff/gql-schema';

const useGetKeywordSearchMagazineInfiniteQuery = <T>(
  variables: Types.GetKeywordSearchMagazineCursorPageQueryVariables,
  queryOptions?: UseInfiniteQueryOptions<Types.GetKeywordSearchMagazineCursorPageQuery, AxiosError, T>
) => {
  return useInfiniteQuery<Types.GetKeywordSearchMagazineCursorPageQuery, AxiosError, T>(
    ['GetKeywordSearchMagazineCursorPage', variables],
    ({ pageParam }) => {
      return useGetKeywordSearchMagazineCursorPageQuery.fetcher({
        request: {
          ...variables.request,
          pivot: pageParam,
        },
      })();
    },
    {
      ...queryOptions,
      getNextPageParam: (lastPage: Types.GetKeywordSearchMagazineCursorPageQuery) => {
        const size = variables.request.size as number;
        if (lastPage.keywordSearchMagazineCursorPage.elements.length < size) {
          return undefined;
        }

        return lastPage.keywordSearchMagazineCursorPage.pivot;
      },
    }
  );
};

export default useGetKeywordSearchMagazineInfiniteQuery;
